import CryptoJS from "crypto-js";
import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";
import { getSafeDeviceInfo } from "../../../utils/deviceUtils";

const ENCRYPTION_KEY = import.meta.env.VITE_AES_KEY;

// export const loginUser = async (email, password) => {
//   //console.log("Login request received", password);
//   try {
//     if (!ENCRYPTION_KEY) {
//       console.error("Encryption key is missing");
//       throw new Error("Configuration error");
//     }

//     const encryptedPassword = CryptoJS.AES.encrypt(
//       password,
//       ENCRYPTION_KEY
//     ).toString();
//     //console.log("Encrypted Password:", encryptedPassword);

//     const response = await axios.get(ENDPOINTS.AUTH.LOGIN, {
//       params: {
//         email,
//         password: encryptedPassword,
//       },
//       withCredentials: true,
//     });

//     if (!response.data) {
//       throw new Error("Empty response from server");
//     }
// console.log('response.data',response.data);
//     return response.data;
//   } catch (error) {
//     console.error("Login error:", error); // Detailed error logging
//     throw error.response?.data?.message || error.message || "Login failed";
//   }
// };

export const loginUser = async (email, password) => {
  const encryptedPassword = CryptoJS.AES.encrypt(
    password,
    ENCRYPTION_KEY
  ).toString();
  if (!ENCRYPTION_KEY) {
    console.error("Encryption key is missing");
    throw new Error("Configuration error");
  }
  const deviceInfo = await getSafeDeviceInfo();
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.AUTH.LOGIN,
    params: {
      email: email,
      password: encryptedPassword,
      deviceType: deviceInfo?.platform,
      ...(deviceInfo?.deviceId && { deviceId: deviceInfo.deviceId }),
      // ...(deviceInfo?.ip && { ipAddress: deviceInfo.ip }),
    },
  });
};

export const logoutUser=async()=>{
  try { 
  await axiosRequest({
    method: "GET",
    url: ENDPOINTS.AUTH.LOGOUT,
    params:{
      coll:"User"
    }
  });
  }catch(e){
    console.error("Logout API ERROR::",e)
  }
}
